import {Fragment, useContext, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {PageHeader, Tab, Tabs} from 'components';
import {UserContext} from 'context';
import {TRANSLATION_KEYS} from 'locale';
import {userAuthUtils} from 'utils';

import {AccountSettings} from './AccountSettings';
import {OAuthSettings} from './OAuthSettings';
import {SecuritySettings} from './SecuritySettings';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SETTINGS;

export const Settings: React.FC = () => {
    const {t} = useTranslation();

    const {common, security, oauth} = useMemo(() =>
        userAuthUtils.getUserPermissions().account.settings, []);

    const {settings: {featuresAvailability}} = useContext(UserContext);

    return (
        <Fragment>
            <PageHeader
                title={t(T_KEYS.TITLE)}
                description={t(T_KEYS.DESCRIPTION)}
            />
            <Tabs>
                <Tab name={t(T_KEYS.SECTIONS.COMMON)} hidden={!common?.enabled}>
                    <AccountSettings />
                </Tab>
                <Tab name={t(T_KEYS.SECTIONS.SECURITY)} hidden={!security?.enabled}>
                    <SecuritySettings />
                </Tab>
                <Tab name={t(T_KEYS.SECTIONS.OAUTH)} hidden={!oauth?.enabled || !featuresAvailability?.oauth}>
                    <OAuthSettings />
                </Tab>
            </Tabs>
        </Fragment>
    );
};